export const CellSchema = () => ({
  title: 'Teaser',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'text', 'image', 'alt', 'link', 'button_text'],
    },
  ],

  properties: {
    title: {
      title: 'Titel',
      type: 'string',
    },
    text: {
      title: 'Text',
      type: 'string',
    },
    image: {
      title: 'Icon',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
    alt: {
      title: 'Image alt Text',
      type: 'string',
    },
    link: {
      title: 'Link auf',
      mode: 'link',
      widget: 'object_browser',
    },
    button_text: {
      title: 'Button Text',
      type: 'string',
    },
  },
  required: [],
});

export const GridSchema = (intl) => ({
  title: 'Schema',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
    {
      id: 'content',
      title: 'Teaser hinzu',
      fields: ['cells'],
    },
  ],

  properties: {
    cells: {
      title: 'Teaser',
      schema: CellSchema(intl),
      widget: 'object_list',
    },
  },
  required: [],
});
